module.exports = __webpack_public_path__ + "static/media/dumbell-gym-healthy-life-svgrepo-com.49013396.svg";